import { lazy, Suspense, useEffect } from 'react';

import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams, Navigate } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import ThankYou from './jsx/pages/ThankYou';
import ConvertPhone from './jsx/pages/ConvertPhone';
import ManageInvite from './jsx/pages/ManageInvite';
import EmailVerificata from './jsx/pages/esito/EmailVerificata';
import { avviaAsterischi } from './jsx/components/Util/asteriscoObbligatori';
import AccountCancellato from './jsx/pages/esito/AccountCancellato';
import GrazieRegistrazione from './jsx/pages/esito/GrazieRegistrazione';

// Pagine di esito raggiunte dai link nelle email: si vedono uguali con o
// senza login, e non devono far partire l'auto-login né il rimando al login.
const PAGINE_ESITO = ['/email-verificata', '/account-cancellato', '/grazie-registrazione'];
const isPaginaEsito = (pathname) => PAGINE_ESITO.includes(pathname.replace(/\/+$/, ''));

const SignUp = lazy(() => import('./jsx/pages/Registration'));
// Flusso trial-con-carta dormiente — riattivare se si torna a richiedere la carta al signup
// const SignUpTrial = lazy(() => import('./jsx/pages/RegistrationTrial'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
	
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App (props) {
  const dispatch = useDispatch();
	const navigate = useNavigate();
  const location = useLocation();

  // Asterisco alla fine dell'etichetta dei campi obbligatori, in tutta l'app
  useEffect(() => { avviaAsterischi(); }, []);

  useEffect(() => {

    let clearToken = false;
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    if (tokenDetailsString) {
      const tokenDetails = JSON.parse(tokenDetailsString);
      //console.log(tokenDetails);
      const expireDate = new Date(tokenDetails.expireDate);
      const currentDate = new Date();
      if (currentDate > expireDate) {
        clearToken = true;
      }
    }

    if(clearToken) {
      sessionStorage.clear();
    }

    if (isPaginaEsito(location.pathname)) return;

    const searchParams = new URLSearchParams(location.search);
    const registerParam = searchParams.get('register');
    const verifiedParam = searchParams.get('verified');
    const autoLoginParam = searchParams.get('autoLogin');
    if (registerParam && registerParam === 'S') {
      navigate('/page-register');
    } else if (verifiedParam === 'S' || verifiedParam === 'A' || verifiedParam === 'E' || autoLoginParam === 'S') {
      // Atterraggio dalla verifica email: nessun login automatico e nessun
      // redirect, così i parametri restano nell'URL e la pagina di login
      // può mostrare il messaggio di esito della verifica.
    } else {
      checkAutoLogin(location, dispatch, navigate);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  let routeblog = ( 
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/login' element={<Login />} />
      <Route path='/page-register' element={<SignUp />} />
      {/* <Route path='/page-register-trial' element={<SignUpTrial />} /> */}
      <Route path='/page-forgot-password' element={<ForgotPassword />} />
      <Route path='/thank-you' element={<ThankYou />} />
      <Route path='/convertphone/:phoneNumber/:userId/:clubId' element={<ConvertPhone />} />
      <Route path='/manageinvite/:phoneNumber/:userId/:clubId/:clubName' element={<ManageInvite />} />
      <Route path='*' element={<Login />} />
    </Routes> 
  );

  if (isPaginaEsito(location.pathname)) {
    return (
      <Routes>
        <Route path='/email-verificata' element={<EmailVerificata />} />
        <Route path='/account-cancellato' element={<AccountCancellato />} />
        <Route path='/grazie-registrazione' element={<GrazieRegistrazione />} />
      </Routes>
    );
  }

  if (props.isAuthenticated) {
    return (
      <>
          <Suspense fallback={
              <div id="preloader">
                  <div className="sk-three-bounce">
                      <div className="sk-child sk-bounce1"></div>
                      <div className="sk-child sk-bounce2"></div>
                      <div className="sk-child sk-bounce3"></div>
                  </div>
              </div>  
              }
          >
            <Index />
          </Suspense>
      </>
    );
	} else {
		return (
			<div className="vh-100">
				<Suspense fallback={
					<div id="preloader">
						<div className="sk-three-bounce">
							<div className="sk-child sk-bounce1"></div>
							<div className="sk-child sk-bounce2"></div>
							<div className="sk-child sk-bounce3"></div>
						</div>
					</div>
				  }
				>
					{routeblog}
				</Suspense>
			</div>
		);
	}
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));